<template>
	<div>
		<div class="headline">Transaction</div>

		<v-row class="summary-grid mt-3" >
			<v-col cols="4">
				<v-row  >
					<v-col cols="3" class="label">Id</v-col>
					<v-col cols="9">{{transaction.id}}</v-col>
					<v-col cols="3" class="label">Queued</v-col>
					<v-col cols="9">{{formatDateTime(transaction.created)}}</v-col>
					<v-col cols="3" class="label">Type</v-col>
					<v-col cols="9">{{transaction.transactionType}}</v-col>
					<v-col cols="3" class="label">Device Id</v-col>
					<v-col cols="9">{{jobstat.deviceId}}</v-col>
					<v-col cols="3" class="label">Status</v-col>
					<v-col cols="9">{{transaction.status}}</v-col>
				</v-row>
			</v-col>
			<v-col cols="4">
				<v-row  >
					<v-col cols="3" class="label">User</v-col>
					<v-col cols="9" :class="{'not-active': !transaction.userActive}">{{transaction.username}}</v-col>
					<v-col cols="3" class="label">IP</v-col>
					<v-col cols="9">{{transaction.requestorIp}}</v-col>
					<v-col cols="3" class="label">Application</v-col>
					<v-col cols="9" :class="{'not-active': !transaction.applicationActive}">{{transaction.application}}</v-col>
					<v-col cols="3" class="label">Patient Id</v-col>
					<v-col cols="9">{{jobstat.patientId}}</v-col>
					<v-col cols="3" class="label">Description</v-col>
					<v-col cols="9">{{transaction.description}}</v-col>
				</v-row>
			</v-col>
			<v-col cols="4">
				<v-row  >
					<v-col cols="3" class="label">Region</v-col>
					<v-col cols="9">{{transaction.region}}</v-col>
					<v-col cols="3" class="label">Customer</v-col>
					<v-col cols="9">{{transaction.customer}}</v-col>
					<v-col cols="3" class="label">Partner</v-col>
					<v-col cols="9" :class="{'not-active': !transaction.partnerActive}">{{transaction.partner}}</v-col>
					<v-col cols="3" class="label">Duration</v-col>
					<v-col cols="9">{{msToHM(jobstat.fileLengthMS)}}</v-col>
				</v-row>
			</v-col>
			<v-col cols="12" v-if="transaction.detailedStatus">
				<div class="label">Status Details</div>
				<div class="code">{{transaction.detailedStatus}}</div>
			</v-col>
		</v-row>
	</div>
</template>
<script>
import { msToHM } from "../../utils";

export default {
	props: ["transaction", "jobstats"],
	data() {
		return {};
	},
	computed: {
		jobstat() {
			return this.jobstats && this.jobstats.length > 0 ? this.jobstats[this.jobstats.length - 1] : { deviceId: null, patientId: null, fileLengthMS: null };
		},
	},
	methods: {
		msToHM,
	},
};
</script>
<style scoped>
.label {
	color: #90A4AE;
}

.col {
	padding-bottom: 6px;
}
</style>
